const vn = {
  updateSuccess: 'hoàn thành cập nhật',
  updateFailed: 'Cập nhật không thành công',
  delOrgSuccess: 'Tổ chức này được xóa thành công và tổ chức tiếp theo sẽ được chuyển đổi cho bạn.',
  delOrgFailed: 'Không thể xóa tổ chức',
  addSuccess: 'Thêm thành công',
  addFailed: 'thêm thất bại',
  authSetSuccess: 'Đã đặt quyền thành công, vui lòng làm mới trang để xem.',
  authSetFailed: 'Cài đặt quyền không thành công',
  disblMemSuccess: 'Thành viên bị vô hiệu hóa thành công',
  disblMemFailed: 'Vô hiệu hóa thành viên không thành công',
  viewOrgRepo: 'Chế độ xem kho tổ chức',
  fullPermissions: 'Tất cả các quyền',
  editOrgDetails: 'Sửa đổi chi tiết tổ chức',
  manageSubOrgs: 'Quản lý tổ chức cấp dưới',
  manageOrgMems: 'Quản lý thành viên tổ chức',
  manageOrgDetailsMems: 'Chi tiết tổ chức và quản lý thành viên',
  orgRepoInbound: 'Tổ chức kho (kho)',
  orgRepoOut: 'Kho tổ chức (outbound)',
  manageSubOrgRepos: 'Quản lý kho của các tổ chức trực thuộc (đến và đi)',
  manageSubOrgAndMeb:'Tổ chức cấp dưới và quản lý thành viên',
  mobileNumber: 'số điện thoại',
  purview: 'Quyền',
  avatar: 'hình đại diện',
  phNumber: 'Số điện thoại',
  setPermissions: 'Cài đặt quyền',
  disable: 'Vô hiệu hóa',
  enable: 'cho phép',
  thisMember:'Các thành viên',
  delOrgTip1: 'Bạn có chắc chắn muốn xóa tổ chức này không?',
  delOrgTip2: 'Thông tin của tổ chức không thể được khôi phục sau khi xóa tổ chức và người dùng thuộc tổ chức đó cũng bị xóa, bạn có xác nhận xóa không?',
  createNewMem: 'Tạo thành viên mới',
  selPerson: 'Hãy chọn một người',
  orgInfo: 'Chi tiết tổ chức',
  addOrg: 'Thêm tổ chức',
  addSubOrgBut: 'Thêm tổ chức cấp dưới',
  members: 'thành viên',
  noMem: 'Chưa có thành viên nào',
  name: 'tên',
  orgNameRequired: 'Tên tổ chức không được để trống!',
  desc: 'mô tả',
  cancel: 'Hủy bỏ',
  memList: 'Danh sách thành viên',
  addOrgMem: 'Thêm thành viên tổ chức',
  selMem: 'Vui lòng chọn một thành viên',
  setMemPurview: 'Đặt quyền thành viên ({{userName}})',
  memDetails: 'Chi tiết thành viên',
  prompt: 'gợi ý',
  conAction: 'Bạn có chắc chắn muốn',
  enterName: 'Vui lòng nhập tên',
  enterDesc: 'Vui lòng nhập mô tả',
  managOrgUser: 'Quản lý hệ thống/người quản lý hệ thống, người quản lý tổ chức|người dùng',
  editOrgBasicInfo: 'Sửa đổi thông tin tổ chức cơ bản',
  manageOrgUsers: 'Quản lý người dùng tổ chức',
  manageOrgProfile: 'Quản lý hồ sơ tổ chức',
  inboundManag: 'Quản lý kho',
  outboundManag: 'Quản lý đầu ra',
  manageSubInv: 'Quản lý hàng tồn kho cấp thấp hơn',
  unPurview:'Quyền không xác định',
  plEnterOrgName: 'Vui lòng nhập tên tổ chức',
  addOrgStru: 'Thêm cơ quan tổ chức',
  noMove: 'Cấm di chuyển cùng cấp',
  addSubOrg: 'Tổ chức cấp dưới thêm ({{name}})',
  noData: 'Không có dữ liệu.',
  delOrgTip3: "Tổ chức này tồn tại tổ chức cấp dưới, xin xóa bỏ tổ chức cấp dưới trước rồi mới xóa bỏ.",
  orgMoveSuc: "Tổ chức Mobile thành công",
  orgMoveFail: "Tổ chức di chuyển thất bại",
  selectAll: "Chọn tất cả",
  userNoOrg: "Người dùng không tham gia vào tổ chức và sẽ thoát đăng nhập sau 5 giây.",
  cancelTip: "Người hiện tại đã được chọn, xác nhận hủy bỏ?",
  delOrg: "Xoá tổ chức",
  plEnterUserName: "Vui lòng nhập số điện thoại Name1, Name2 để tìm kiếm",
  noOrgData: "Không tìm thấy dữ liệu/tổ chức có thể bị xóa",
  orgFetchFail: 'Lỗi lấy thông tin tổ chức',
  orgListEmpty: "Hiện tại chưa có tổ chức, xin vui lòng thêm tổ chức trước.",
  selectOrg: "Vui lòng chọn tổ chức trước",
  orgDisabled: "Tổ chức đã bị vô hiệu hóa hoặc không tồn tại",
  modifyOrgInfo: "Sửa đổi thông tin tổ chức",
  addOrDisableOrgMember: "Thêm/vô hiệu hóa thành viên của tổ chức",
  orgMemberPermissions: "Thiết lập quyền cho thành viên của tổ chức",
};

export default vn;